import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal';
import styles from './index.module.scss';
import PrimaryButton from '../Buttons/PrimaryButton';
import dayjs from 'dayjs';
import IT from '../../../shared/Lenguages/it.json';
import EN from '../../../shared/Lenguages/en.json';
import FR from '../../../shared/Lenguages/fr.json';
import useWindowSize from '../../../utils/useWindowSize';
import clsx from 'clsx';

const LanguageSelectorModal = ({ isOpen, onClose, closeButton = false }) => {
  const { i18n } = useTranslation();
  const { isMobile } = useWindowSize();

  const languages = [
    { code: 'it', name: 'Italiano', flag: '🇮🇹', translations: IT },
    { code: 'en', name: 'English', flag: '🇬🇧', translations: EN },
    { code: 'fr', name: 'Français', flag: '🇫🇷', translations: FR },
  ];

  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || 'it');
  const [currentTranslations, setCurrentTranslations] = useState(IT);

  useEffect(() => {
    const selectedLang = languages.find(lang => lang.code === selectedLanguage);
    if (selectedLang) {
      setCurrentTranslations(selectedLang.translations);
    }
  }, [selectedLanguage]);

  const handleLanguageSelect = (languageCode) => {
    setSelectedLanguage(languageCode);
  };

  const handleConfirm = async () => {
    try {
      // Cambia la lingua solo quando confermiamo
      await i18n.changeLanguage(selectedLanguage);
      dayjs.locale(selectedLanguage);
      
      // Salva la lingua nel localStorage
      localStorage.setItem('i18nextLng', selectedLanguage);
      
      onClose();
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  return (
    <Modal
      isModalOpen={isOpen}
      setIsModalOpen={onClose}
      title={currentTranslations.languageSelector?.title || "Seleziona una Lingua"}
      subTitle={""}
      width={isMobile ? '100%' : '400px'}
      height={isMobile ? '100%' : '500px'}
      showCloseBtn={closeButton}
    >
      <div className={styles.container}>
        <p className={styles.description}>
          {currentTranslations.languageSelector?.description || "Seleziona la tua lingua preferita per continuare a utilizzare l'applicazione."}
        </p>
        
        <div className={styles.languageList}>
          {languages.map((language) => (
              <div
                key={language.code}
                className={clsx(styles.languageOption)}
                onClick={() => handleLanguageSelect(language.code)}
              >
                <input className={styles.radio_button} type='radio' checked={selectedLanguage === language.code} readOnly={true} />
                <span className={styles.flag}>{language.flag}</span>
                <span className={styles.name}>{language.name}</span>
                
              </div>
          ))}
        </div>
        <div className={styles.actions}>
          <PrimaryButton
            text={currentTranslations?.common?.actions?.confirm || "Conferma"}
            onClick={handleConfirm}
            width="100%"
            height='50px'
            borderRadius='8px'
          />
        </div>
      </div>
    </Modal>
  );
};

export default LanguageSelectorModal;
